import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#08080A] flex items-center justify-center text-[#D4AF37] text-sm tracking-widest uppercase">
        Loading…
      </div>
    );
  }
  if (user === null) return <Navigate to="/portal" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/portal/dashboard" replace />;
  return children;
}
